import { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import { CHANNEL_LIST_PATH } from '../../../common/constants/routePath';
import { TYPE_ERROR } from '../../../common/constants/snackbar';

import * as commonSelectors from '../../../common/redux/selectors/common';
import { notifyAction } from '../../../common/redux/slices/snackbar';

function ChannelExistsValidation({ notifyError = true, ...props }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const channels = useSelector(commonSelectors.channelsSelector);

  const targetChannel = channels.some((channel) => channel.id === +params.channel);

  useLayoutEffect(() => {
    if (!targetChannel) {
      if (notifyError) {
        dispatch(
          notifyAction({
            variant: TYPE_ERROR,
            message: "Channel doesn't exist",
          }),
        );
      }

      navigate(CHANNEL_LIST_PATH, { replace: true });
    }
  }, [notifyError, params.channel, targetChannel, channels]);

  return targetChannel ? props.children : null;
}

ChannelExistsValidation.propTypes = {
  notifyError: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default ChannelExistsValidation;
